import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useApp } from '../contexts/AppContext';

/**
 * Jeton magique de partage QR — permet à un moniteur de partager un lien
 * cours à des élèves non inscrits en ajoutant ?share=c2r à l'URL.
 * (Simple mais suffisant : il faut connaître la valeur pour accéder.)
 */
const SHARE_TOKEN = 'c2r';

/**
 * Vérifie la présence d'un token de partage QR dans l'URL (query ou sessionStorage).
 * Persiste le token en session pour que la navigation interne (Liens, réloads) fonctionne.
 */
function hasValidShareToken() {
  try {
    const params = new URLSearchParams(window.location.search);
    const urlToken = params.get('share');
    if (urlToken === SHARE_TOKEN) {
      // Sauvegarde en session pour navigation ultérieure
      sessionStorage.setItem('c2r-share', '1');
      return true;
    }
    return sessionStorage.getItem('c2r-share') === '1';
  } catch {
    return false;
  }
}

export const ProtectedRoute = ({ children, roles, allowShare = true }) => {
  const { user, loading } = useApp();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="protected-loading">
        <div className="text-muted-foreground">Chargement...</div>
      </div>
    );
  }

  // ▶ Bypass via QR partagé : permet à un élève non inscrit d'accéder
  //   si un moniteur lui a partagé le lien avec ?share=c2r
  if (allowShare && !user && hasValidShareToken()) {
    return children;
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }

  if (roles && !roles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
